import { render, staticRenderFns } from "./DataJb.vue?vue&type=template&id=0192d11f&scoped=true&"
import script from "./DataJb.vue?vue&type=script&lang=js&"
export * from "./DataJb.vue?vue&type=script&lang=js&"
import style0 from "./DataJb.vue?vue&type=style&index=0&lang=less&"
import style1 from "./DataJb.vue?vue&type=style&index=1&id=0192d11f&lang=less&scoped=scoped&"
import style2 from "./DataJb.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0192d11f",
  null
  
)

export default component.exports